export default "__VITE_ASSET__C4Ag_FZN__"